import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';
import { Store } from '@ngrx/store';
import { first } from 'rxjs/operators';

import { Order } from '@api/order/order.models';
import { CommonWindow } from '@core/domain/models/common-window.model';
import { getStoreAndLanguage } from '@core/infrastructure/state/core.selectors';
import { CoreStorageService } from '@core/services/storage/storage.service';
import { UiService } from '@core/services/ui.service';

@Injectable({ providedIn: 'root' })

/**
 * Servicio para realizar el seguimiento/analítica con Nostromo
 */
export class NostromoService {
    private readonly nostromoBaseUrl = 'https://nostropix.com/nostropix.php/';

    private storeId: string;

    constructor(
        private readonly uiService: UiService,
        private readonly http: HttpClient,
        private readonly storageService: CoreStorageService,
        private readonly store: Store,
        @Inject(WINDOW) private readonly window: CommonWindow,
    ) {
        this.store.select(getStoreAndLanguage).subscribe((res) => {
            this.storeId = res.storeId;
        });
    }

    // ------------ PUBLIC METHODS ------------

    public login() {
        this.doRequest(10, 0);
    }

    public loginDone() {
        this.doRequest(10, 1);
    }

    public register() {
        this.doRequest(20, 0);
    }

    public registerDone() {
        this.doRequest(20, 1);
    }

    public recoverPasswd() {
        this.doRequest(15, 0);
    }

    public recoverPasswdDone() {
        this.doRequest(15, 1);
    }

    public payment(paymentMethodCode) {
        if (this.canNotifyStartPayment()) {
            this.doRequest(50, 0);
            this.notifyStartPaymentWithInfo(paymentMethodCode);
            this.doRequest(40, 1);
        }
    }

    public paymentDone(order: Order) {
        if (!order) {
            this.doRequest(50, 1);
        } else if (order.id !== -1) {
            this.notifyEndPaymentWithInfo(order);
        }
    }

    public checkout() {
        this.doRequest(40, 0); // CHECKOUT
        this.doRequest(30, 1); // CART DONE
    }

    public cart() {
        this.doRequest(30, 0);
    }

    // ------------ PRIVATE METHODS ------------

    private getDevice(): number {
        const deviceInfo = this.uiService.get();
        if (deviceInfo.device.desktop) {
            return 12; // DESKTOP
        }
        return 11; // MOBILE
    }

    private canNotifyStartPayment(): boolean {
        return true;
    }

    private notifyStartPaymentWithInfo(paymentMethodCode) {
        const complexPaymentId = '' + 50 + paymentMethodCode;
        this.doRequest(complexPaymentId, 0);
    }

    private notifyEndPaymentWithInfo(order: Order) {
        const orderString = this.storageService.getValue<string>('ord_nost', 'SESSION');
        let orders = [];
        if (orderString && typeof orderString === 'string') {
            orders = orderString.split(',');
        }
        if (!orders.includes(order.id.toString())) {
            orders.push(order.id.toString());
            this.storageService.setValue('ord_nost', orders.join(','), 'SESSION', 'TECHNICAL');
            const payment = order.payment[0];
            this.doRequest(50, 1);
            if (payment) {
                const complexPaymentId = '' + 50 + payment.code;
                this.doRequest(complexPaymentId, 1);
            }
        }
    }

    private doRequest(event: any, status: number) {
        if (this.window.location.hostname === 'www.massimodutti.com') {
            // eslint-disable-next-line no-console
            console.log('NOSTROMO APOLLO - ', event, status);
            const device = this.getDevice();
            const url = `${this.nostromoBaseUrl}${this.storeId}/${event}/${device}/${status}`;
            // eslint-disable-next-line rxjs/no-ignored-subscribe
            this.http.get(url).pipe(first()).subscribe();
        }
    }
}
